// theme.js

import { extendTheme } from "@chakra-ui/react";
const activeLabelStyles = {
  transform: "scale(0.85) translateY(-24px)"
};
const theme = extendTheme({
    components: {
      Radio: {
        baseStyle: {
          control: {
            _before: {
              content: '""',
              width: '100% !important',
            height: '100% !important',
            
            },
          },
        },
      },
      Tabs: {
        baseStyle: {

          tab: {
            
            _selected: {
              bg: '#BCD9AE',
              color:`black`,
              borderRadius:"10px"
              
            }
          }
        }
      }, 
     
      Input: {
        defaultProps: {
          focusBorderColor: "#7BB564",
          padding:"20px 0px 0px 0px",
          fontSize:"41px"
        }
      },FormLabel:{
       
          padding:"20px 0px 0px 20px",
        
      },
      // Form: {
      //   variants: {
      //     floating: {
      //       container: {
      //         _focusWithin: {

      //           label: {
      //             ...activeLabelStyles
      //           }
      //         },
      //         "input:not(:placeholder-shown) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown) ~ label": {
      //           ...activeLabelStyles
      //         },
           
      //         label: {
      //           top: 0,
      //           left: 0,
      //           zIndex: 2,
      //           position: "absolute",
      //           backgroundColor: "white",
      //           pointerEvents: "none",
      //           mx: 3,
      //           px: 1,
      //           my: 2,
      //           transformOrigin: "left top"
      //         }
      //       }
      //     }
      //   }
      // }
    }
  })

export default theme;


// export const theme = extendTheme({
//   components: {
   
//   }
// });
